import { GetContentsSource } from "@robe/core-api";
import { Content } from "@robe/core-types";
// import fs from "fs/promises";
// import path from "path";

export type DebugBlocks = "routing" | "filters" | "link" | "pdf-ep";

// todo after t3 env is implemented remove this and resolve value in config
export const resolveEnabledDebugBlocks = (block: DebugBlocks) => {
  if (!process.env.NEXT_PUBLIC_ENABLED_DEBUG_BLOCKS) {
    return true;
  }

  const enabled = (process.env.NEXT_PUBLIC_ENABLED_DEBUG_BLOCKS || "").split(",").map((x) => x.trim());

  return enabled.includes(block);
};

interface SaveNotFoundContentsParams<T extends Content = Content> {
  source: GetContentsSource<T>;
  contents: Array<Partial<Content>>;
  url: string;
}

// todo leave this for debug purposes, usable in contents queries
export const saveNotFoundContents = async <T extends Content = Content>({ source, url, contents }: SaveNotFoundContentsParams<T>) => {
  if ("types" in source && Array.isArray(source.types)) {
    const notFoundCts: string[] = [];

    source.types.forEach(async (t) => {
      const notFoundContent = contents.find((c) => c.type === t);

      if (!notFoundContent) {
        console.log({ typeNotFound: t, url });

        notFoundCts.push(t);
      }
    });

    // if (notFoundCts.length > 0) {
    //   const filePath = path.join(process.cwd(), `${new Date().toISOString()}.json`);
    //   await fs.writeFile(filePath, JSON.stringify({ apiReq: url, notFoundCts, contents }, null, 2));
    // }
  }
};
